import React from 'react';
import Button from '@atlaskit/button';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { useIntl } from '@atlassian/jira-intl';
import {
	INVALID_DELETE_MODAL_SELECTOR,
	INVALID_DELETE_MODAL_CONFIRM_BUTTON_SELECTOR,
} from '../../../common/constants';
import { messages } from './messages';

export type InvalidDeleteModalViewProps = {
	schemeName: string;
	associatedProjectCount: number;
	onComplete: () => void;
};

export const InvalidDeleteModalView = ({
	schemeName,
	onComplete,
	associatedProjectCount,
}: InvalidDeleteModalViewProps) => {
	const { formatMessage } = useIntl();
	return (
		<Modal testId={INVALID_DELETE_MODAL_SELECTOR} onClose={onComplete}>
			<ModalHeader>
				<ModalTitle>{formatMessage(messages.invalidDeleteModalTitleNew)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				{formatMessage(messages.invalidDeleteModalNAssociatedProjectDescriptionNew, {
					schemeName,
					associatedProjectCount,
				})}
			</ModalBody>
			<ModalFooter>
				<Button
					testId={INVALID_DELETE_MODAL_CONFIRM_BUTTON_SELECTOR}
					appearance="primary"
					onClick={onComplete}
					autoFocus
				>
					{formatMessage(messages.invalidDeleteModalCompleteButtonNew)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
